import React from 'react';
import { NavLink } from 'react-router-dom';
import { LayoutDashboard, CalendarDays, Users, MapPin, Tags, FileText, LogOut } from 'lucide-react';
import { useAuth } from '../AuthContext';
interface AdminSidebarProps {
  isOpen: boolean;
  setIsOpen: (v: boolean) => void;
}
export function AdminSidebar({
  isOpen,
  setIsOpen
}: AdminSidebarProps) {
  const {
    logout
  } = useAuth();
  const links = [{
    to: '/admin',
    icon: LayoutDashboard,
    label: 'Dashboard',
    end: true
  }, {
    to: '/admin/availability',
    icon: CalendarDays,
    label: 'Disponibilidad'
  }, {
    to: '/admin/sessions',
    icon: CalendarDays,
    label: 'Calendario'
  }, {
    to: '/admin/bookings',
    icon: Users,
    label: 'Reservas'
  }, {
    to: '/admin/locations',
    icon: MapPin,
    label: 'Ubicaciones'
  }, {
    to: '/admin/class-types',
    icon: Tags,
    label: 'Tipos de Clase'
  }];
  return <aside className={`fixed inset-y-0 left-0 z-40 w-64 bg-earth text-cream transform transition-transform duration-300 ease-in-out ${isOpen ? 'translate-x-0' : '-translate-x-full'} md:translate-x-0 flex flex-col`} data-id="element-517">
      <div className="p-6 border-b border-cream/10 flex items-center justify-between" data-id="element-518">
        <h2 className="font-display text-2xl font-bold text-cream" data-id="element-519">
          Vimutti Admin
        </h2>
      </div>

      <nav className="flex-1 p-4 space-y-2 overflow-y-auto" data-id="element-520">
        {links.map(link => <NavLink key={link.to} to={link.to} end={link.end} onClick={() => setIsOpen(false)} className={({
        isActive
      }) => `flex items-center gap-3 px-4 py-3 rounded-xl transition-colors ${isActive ? 'bg-sage text-white shadow-sm' : 'text-cream/70 hover:bg-cream/10 hover:text-cream'}`} data-id="element-521">
            <link.icon size={20} data-id="element-522" />
            <span className="font-medium text-sm" data-id="element-523">{link.label}</span>
          </NavLink>)}
      </nav>

      <div className="p-4 border-t border-cream/10" data-id="element-524">
        <button onClick={logout} className="flex items-center gap-3 px-4 py-3 w-full rounded-xl text-cream/70 hover:bg-error/20 hover:text-error transition-colors text-left" data-id="element-525">
          <LogOut size={20} data-id="element-526" />
          <span className="font-medium text-sm" data-id="element-527">Cerrar Sesión</span>
        </button>
      </div>
    </aside>;
}